import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators'
import { IMensagemAplicativo } from 'src/app/interfaces/sorei-saishi';

/*
  Generated class for the InstituicaoProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable({providedIn: 'root'})
export class InstituicaoProvider {

  baseUrl = environment.API_URL;
  constructor(public http: HttpClient) {

  }

  getDadosServidor() {
    return this.http.get<any>(this.baseUrl + '/instituicao/dados', {
      params: { 'expand': 'contato,endereco,links,nomenclatura,configPortalAplicativo' }
    })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  getImagemFundo() {
    return this.http.get<any>(this.baseUrl +'/instituicao/imagem-fundo');
  }

  getInstituicaoList(filtro: any, pag: { currentPage: any; }) {
    return this.http.get<any>(this.baseUrl + '/instituicao/instituicao-list',
      {
        observe: 'response', params:
        {
          "page": pag.currentPage,
          "per-page": "10",
          "filtro": filtro,
        }
      })
      .pipe(map(data => {
        let pag = {
          currentPage: data.headers.get("X-Pagination-Current-Page"),
          pageCount: data.headers.get("X-Pagination-Page-Count"),
          perPage: data.headers.get("X-Pagination-Per-Page"),
          totalCount: data.headers.get("X-Pagination-Total-Count"),
        };
        return {
          instituicao: data.body,
          pagination: pag
        };
      }));
  }

  criarSolicitacao(mensagem: any, tipo: any) {
    return this.http.post<any>(this.baseUrl + '/instituicao/solicitacao',
      { mensagem: mensagem, tipo: tipo })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  public getInstituicaoCadastro(id: any) {
    return this.http.post<any>(this.baseUrl + '/cadastro/get-instituicao', { 'id': id })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  getInstituicoesVinculadas() {
    return this.http.get<any>(this.baseUrl + '/instituicao/get-instituicoes-vinculadas', {observe: 'response'
      })
      .pipe(map(data => {
        return data.body;
      }));
  }

  public hasConfigSede(idConfiguracao: string) {
    return this.http
    .get<boolean>(this.baseUrl + '/instituicao/has-config-sede', {
      params: {
        idConfiguracao: idConfiguracao
      },
    })
    .pipe(map((data) => {
      return data;
    }));
  }

  public compareInstituicoes(idInstituicaoLeitor: any, parsedQrCodeIdInstituicao: any) {
    return this.http
    .get<boolean>(this.baseUrl + '/instituicao/compare-instituicoes', {
      params: {
        idInstituicaoLeitor: idInstituicaoLeitor,
        parsedQrCodeIdInstituicao: parsedQrCodeIdInstituicao
      },
    })
    .pipe(map((data) => {
      return data;
    }));
  }


  public objDddi(): { [key: string]: string } {
    return {
      '+247': 'ac',
      '+376': 'ad',
      '+971': 'ae',
      '+93': 'af',
      '+355': 'al',
      '+374': 'am',
      '+599': 'an',
      '+244': 'ao',
      '+672': 'aq',
      '+54': 'ar',
      '+43': 'at',
      '+61': 'au',
      '+297': 'aw',
      '+994': 'az',
      '+387': 'ba',
      '+880': 'bd',
      '+32': 'be',
      '+226': 'bf',
      '+359': 'bg',
      '+973': 'bh',
      '+257': 'bi',
      '+229': 'bj',
      '+673': 'bn',
      '+591': 'bo',
      '+55': 'br',
      '+975': 'bt',
      '+267': 'bw',
      '+375': 'by',
      '+501': 'bz',
      '+243': 'cd',
      '+236': 'cf',
      '+242': 'cg',
      '+41': 'ch',
      '+225': 'ci',
      '+682': 'ck',
      '+56': 'cl',
      '+237': 'cm',
      '+86': 'cn',
      '+57': 'co',
      '+506': 'cr',
      '+53': 'cu',
      '+238': 'cv',
      '+357': 'cy',
      '+420': 'cz',
      '+49': 'de',
      '+253': 'dj',
      '+45': 'dk',
      '+213': 'dz',
      '+593': 'ec',
      '+372': 'ee',
      '+20': 'eg',
      '+291': 'er',
      '+34': 'es',
      '+251': 'et',
      '+358': 'fi',
      '+679': 'fj',
      '+500': 'fk',
      '+691': 'fm',
      '+298': 'fo',
      '+590': 'fr',
      '+241': 'ga',
      '+995': 'ge',
      '+594': 'gf',
      '+233': 'gh',
      '+350': 'gi',
      '+299': 'gl',
      '+220': 'gm',
      '+224': 'gn',
      '+240': 'gq',
      '+30': 'gr',
      '+502': 'gt',
      '+245': 'gw',
      '+592': 'gy',
      '+852': 'hk',
      '+504': 'hn',
      '+385': 'hr',
      '+509': 'ht',
      '+36': 'hu',
      '+62': 'id',
      '+353': 'ie',
      '+972': 'il',
      '+91': 'in',
      '+246': 'io',
      '+964': 'iq',
      '+98': 'ir',
      '+354': 'is',
      '+39': 'it',
      '+962': 'jo',
      '+81': 'jp',
      '+254': 'ke',
      '+996': 'kg',
      '+855': 'kh',
      '+686': 'ki',
      '+269': 'km',
      '+850': 'kp',
      '+82': 'kr',
      '+965': 'kw',
      '+7': 'kz',
      '+856': 'la',
      '+961': 'lb',
      '+423': 'li',
      '+94': 'lk',
      '+231': 'lr',
      '+266': 'ls',
      '+370': 'lt',
      '+352': 'lu',
      '+371': 'lv',
      '+218': 'ly',
      '+212': 'ma',
      '+377': 'mc',
      '+373': 'md',
      '+382': 'me',
      '+261': 'mg',
      '+692': 'mh',
      '+389': 'mk',
      '+223': 'ml',
      '+95': 'mm',
      '+976': 'mn',
      '+853': 'mo',
      '+596': 'mq',
      '+222': 'mr',
      '+356': 'mt',
      '+230': 'mu',
      '+960': 'mv',
      '+265': 'mw',
      '+52': 'mx',
      '+60': 'my',
      '+258': 'mz',
      '+264': 'na',
      '+687': 'nc',
      '+227': 'ne',
      '+234': 'ng',
      '+505': 'ni',
      '+31': 'nl',
      '+47': 'no',
      '+977': 'np',
      '+674': 'nr',
      '+683': 'nu',
      '+64': 'nz',
      '+968': 'om',
      '+507': 'pa',
      '+51': 'pe',
      '+689': 'pf',
      '+675': 'pg',
      '+63': 'ph',
      '+92': 'pk',
      '+48': 'pl',
      '+970': 'ps',
      '+351': 'pt',
      '+680': 'pw',
      '+595': 'py',
      '+974': 'qa',
      '+262': 're',
      '+40': 'ro',
      '+381': 'rs',
      '+250': 'rw',
      '+966': 'sa',
      '+677': 'sb',
      '+248': 'sc',
      '+249': 'sd',
      '+46': 'se',
      '+65': 'sg',
      '+290': 'sh',
      '+386': 'si',
      '+421': 'sk',
      '+232': 'sl',
      '+378': 'sm',
      '+221': 'sn',
      '+252': 'so',
      '+597': 'sr',
      '+211': 'ss',
      '+239': 'st',
      '+503': 'sv',
      '+963': 'sy',
      '+268': 'sz',
      '+235': 'td',
      '+228': 'tg',
      '+66': 'th',
      '+992': 'tj',
      '+690': 'tk',
      '+670': 'tl',
      '+993': 'tm',
      '+216': 'tn',
      '+676': 'to',
      '+90': 'tr',
      '+688': 'tv',
      '+886': 'tw',
      '+255': 'tz',
      '+380': 'ua',
      '+256': 'ug',
      '+44': 'gb',
      '+1': 'us',
      '+598': 'uy',
      '+998': 'uz',
      '+58': 've',
      '+84': 'vn',
      '+678': 'vu',
      '+681': 'wf',
      '+685': 'ws',
      '+967': 'ye',
      '+27': 'za',
      '+260': 'zm',
      '+263': 'zw',
    };
  }

  public objectMask() {
    return {
      ac: '0000',
      ad: '000-000',
      ae: '00-000-0000',
      af: '00-000-0000',
      ag: '(000)000-0000',
      ai: '(000)000-0000',
      al: '(000)000-000',
      am: '00-000-000',
      an: '0000-0000',
      ao: '(000)000-000',
      aq: '000-000',
      ar: '(000)000-0000',
      as: '(000)000-0000',
      at: '(000)000-0000',
      au: '0-0000-0000',
      aw: '000-0000',
      az: '00-000-00-00',
      ba: '00-00000',
      bb: '(000)000-0000',
      bd: '00-000-000',
      be: '(000)000-000',
      bf: '00-00-0000',
      bg: '(000)000-000',
      bh: '0000-0000',
      bi: '00-00-0000',
      bj: '00-00-0000',
      bm: '(000)000-0000',
      bn: '000-0000',
      bo: '0-000-0000',
      br: '(00)00000-0000',
      bs: '(000)000-0000',
      bt: '00-000-000',
      bw: '00-000-000',
      by: '(00)000-00-00',
      bz: '000-0000',
      ca: '(000)000-0000',
      cd: '(000)000-000',
      cf: '00-00-0000',
      cg: '00-000-0000',
      ch: '00-000-0000',
      ci: '00-000-000',
      ck: '00-000',
      cl: '0-0000-0000',
      cm: '0000-0000',
      cn: '(000)0000-0000',
      co: '(000)000-0000',
      cr: '0000-0000',
      cu: '0-000-0000',
      cv: '(000)00-00',
      cw: '000-0000',
      cy: '00-000-000',
      cz: '(000)000-000',
      de: '(0000)000-0000',
      dj: '00-00-00-00-00',
      dk: '00-00-00-00-00',
      dm: '(000)000-0000',
      do: '(000)000-0000',
      dz: '00-000-0000',
      ec: '00-000-0000',
      ee: '0000-0000',
      eg: '(000)000-0000',
      er: '0-000-000',
      es: '(000)000-000',
      et: '00-000-0000',
      fi: '(000)000-00-00',
      fj: '00-00000',
      fk: '00000',
      fm: '000-0000',
      fo: '000-000',
      fr: '(000)000-000',
      ga: '0-00-00-00-00',
      gd: '(000)000-0000',
      ge: '(000)000-000',
      gf: '00000-0000',
      gh: '(000)000-000',
      gi: '000-00000',
      gl: '00-00-00-00',
      gm: '(000)00-00',
      gn: '00-000-000',
      gq: '00-000-0000',
      gr: '(000)000-0000',
      gt: '0-000-0000',
      gu: '(000)000-0000',
      gw: '0-000000',
      gy: '000-0000',
      hk: '0000-0000',
      hn: '0000-0000',
      hr: '00-000-000',
      ht: '00-00-0000',
      hu: '(000)000-000',
      id: '(000)000-00-000',
      ie: '(000)000-000',
      il: '00-000-0000',
      in: '(0000)000-000',
      io: '000-0000',
      iq: '(000)000-0000',
      ir: '(000)000-0000',
      is: '000-0000',
      it: '(000)0000-000',
      jm: '(000)000-0000',
      jo: '0-0000-0000',
      jp: '(000)000-000',
      ke: '000-000-0000',
      kg: '(000)000-000',
      kh: '00-000-000',
      ki: '00-000',
      km: '00-00000',
      kn: '(000)000-0000',
      kp: '000-0000-000',
      kr: '00-000-0000',
      kw: '0000-0000',
      ky: '(000)000-0000',
      kz: '(000)000-00-00',
      la: '(0000)000-000',
      lb: '00-000-000',
      lc: '(000)000-0000',
      li: '(000)000-0000',
      lk: '00-000-0000',
      lr: '00-000-000',
      ls: '0-000-0000',
      lt: '(000)00-000',
      lu: '(000)000-000',
      lv: '00-000-000',
      ly: '00-000-000',
      ma: '00-0000-000',
      mc: '(000)000-000',
      md: '0000-0000',
      me: '00-000-000',
      mg: '00-00-00000',
      mh: '000-0000',
      mk: '00-000-000',
      ml: '00-00-0000',
      mm: '00-000-000',
      mn: '00-00-0000',
      mo: '0000-0000',
      mp: '(000)000-0000',
      mq: '(000)00-00-00',
      mr: '00-00-0000',
      ms: '(000)000-0000',
      mt: '0000-0000',
      mu: '000-0000',
      mv: '000-0000',
      mw: '0-0000-0000',
      mx: '(000)000-0000',
      my: '(000)000-000',
      mz: '00-000-000',
      na: '00-000-0000',
      nc: '00-0000',
      ne: '00-00-0000',
      nf: '000-000',
      ng: '(000)000-0000',
      ni: '0000-0000',
      nl: '00-000-0000',
      no: '(000)00-000',
      np: '00-000-000',
      nr: '000-0000',
      nu: '0000',
      nz: '(000)000-000',
      om: '00-000-000',
      pa: '000-0000',
      pe: '(000)000-000',
      pf: '00-00-00',
      pg: '(000)00-000',
      ph: '(000)000-0000',
      pk: '(000)000-0000',
      pl: '(000)000-000',
      ps: '00-000-0000',
      pt: '00-000-0000',
      pw: '000-0000',
      py: '(000)000-000',
      qa: '0000-0000',
      re: '00000-0000',
      ro: '00-000-0000',
      rs: '00-000-0000',
      ru: '(000)000-00-00',
      rw: '(000)000-000',
      sa: '(0000) 000 000',
      sb: '000-0000',
      sc: '0-000-000',
      sd: '00-000-0000',
      se: '00-000-0000',
      sg: '0000-0000',
      sh: '0000',
      si: '00-000-000',
      sk: '(000)000-000',
      sl: '00-000000',
      sm: '0000-000000',
      sn: '00-000-0000',
      so: '00-000-000',
      sr: '000-0000',
      ss: '00-000-0000',
      st: '00-00000',
      sv: '00-00-0000',
      sx: '(000)000-0000',
      sy: '00-0000-000',
      sz: '00-00-0000',
      tc: '(000)000-0000',
      td: '00-00-00-00',
      tg: '00-000-000',
      th: '00-000-0000',
      tj: '00-000-0000',
      tk: '0000',
      tl: '000-0000',
      tm: '0-000-0000',
      tn: '00-000-000',
      to: '00000',
      tr: '(000)000-0000',
      tt: '(000)000-0000',
      tv: '000000',
      tw: '0-0000-0000',
      tz: '00-000-0000',
      ua: '(00)000-00-00',
      ug: '(000)000-000',
      gb: '00-0000-000000',
      us: '(000)000-0000',
      uy: '0-000-00-00',
      uz: '00-000-0000',
      va: '0-000-00000',
      vc: '(000)000-0000',
      ve: '(000)000-0000',
      vg: '(000)000-0000',
      vi: '(000)000-0000',
      vn: '(000)0000-000',
      vu: '00-00000',
      wf: '00-0000',
      ws: '00-0000',
      ye: '000-000-000',
      za: '00-000-0000',
      zm: '00-000-0000',
      zw: '0-000000',
    };
  }

  public ddiPaises() {
    return {
      2: '+971',
      9: '+244',
      26: '+591',
      27: '+55',
      33: '+1',
      38: '+41',
      41: '+56',
      62: '+34',
      69: '+33',
      71: '+44',
      86: '+245',
      100: '+39',
      103: '+81',
      123: '+352',
      144: '+52',
      172: '+595',
      170: '+351',
      214: '+598',
      230: '+1',
    };
  }

  getAplicativoMensagemByTipo(tipo: string[]) {
    return this.http
      .get<IMensagemAplicativo[]>(
        this.baseUrl + "/aplicativo-mensagem/get-aplicativo-mensagem-by-tipo",
        {
          params: {
            tipo: tipo.join(","),
          },
        },
      )
      .pipe(map((data) => {
        return data ? data : false;
      }));
  }
}
